import { render, staticRenderFns } from "./account-verification.vue?vue&type=template&id=59339ae0&scoped=true"
import script from "./account-verification.vue?vue&type=script&lang=js"
export * from "./account-verification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59339ae0",
  null
  
)

export default component.exports